import React, { forwardRef, useState } from "react";


// =====================================================
//  Basically this is custom Input. We can use this any where on the website
//  Reusable component
// =====================================================

const CustomInput = (
  {
    component: Component = "input",
    className = "",
    wrapperClassName = "",
    labelClassName = "",
    label = "",
    wrapperProps,
    labelProps,
    onChange,
    ...props
  },
  ref
) => {
 
  const [hasVal, setHasVal] = useState(false);
  const change = (e) => (e.target.value ? setHasVal(true) : setHasVal(false));
  return (
    <div
      className={`wrap-input100 validate-input 
      ${props.blueborder ? 'outline-blue': ''}
      ${wrapperClassName} ${props.error === "true" ? "errorInput": "" }`}
      data-validate={`Enter ${label}`}
      {...wrapperProps}
    >
        {props?.start_icon &&
        <span className="input_start_icon">
            {props.start_icon}
        </span>}
      <Component
        {...props}
        ref={ref}
        onChange={(e) => {
          change(e);
          onChange?.(e);
        }}
        className={` input100 ${
          hasVal || props.value ? "has-val" : ""
        } ${className} `}
      />
      {props?.end_icon && 
      <span className="input_end_icon">
        {props.end_icon}
      </span>
      }
      <span
        {...labelProps}
        className={`focus-input100 ${labelClassName}`}
        data-placeholder={label}
      ></span>
     
    </div>
  );
};

export default forwardRef(CustomInput);
